<div class="fulfill-header">
  <div class="fulfill-header__title">
    <h2>Fulfill your batches</h2>
  </div>
  <div class="fulfill-header__search">
    <pdq-input
      placeholder="Search in Fulfill"
      (onKeyup)="usePaginatedFulfillment() ? searchQuery.set($event) : filterTable($event)"></pdq-input>
  </div>
</div>
